import { ReactNode } from 'react'

type THero = {
  readonly pathname: string
  readonly children?: ReactNode
}

export default function Hero({ pathname, children }: THero) {
  const heroText = {
    '/profile': {
      page: 'Profile',
      title: 'Manage Your Profile',
      description: 'Manage your account settings.',
    },
    '/notification-settings': {
      page: 'Notification Settings',
      title: 'Manage Notification',
      description: 'Change your notification settings.',
    },
    '/survey-history': {
      page: 'Submission History',
      title: 'Your Submission History',
      description: 'Track completed surveys status.',
    },
    '/rewards': {
      page: 'Rewards',
      title: 'Your Earnings',
      description: '',
    },
    '/articles/terms-and-condition': {
      page: 'Terms and Condition',
      title: 'Our Terms of Service',
      description:
        'Read our terms below to learn more about your rights and responsibilities as a Responova user.',
    },
    '/articles/privacy-policy': {
      page: 'Privacy Policy',
      title: 'Our Commitment to Protecting Your Privacy',
      description:
        'Learn more about how Responova collects and uses data and your rights as a Responova user.',
    },
  }[pathname]

  if (!heroText) {
    return null
  }

  return (
    <div className='bg-gradient-to-b from-pop-blue-700 to-pop-blue-600 p-5'>
      <div className='mx-auto flex flex-col items-center gap-3 px-5 py-5 md:w-1/2 lg:w-1/2 xl:w-1/3'>
        <div className='flex flex-row items-center justify-center rounded-full bg-pop-blue-100 px-2 py-1'>
          <span className='text-xs font-medium text-pop-blue-700'>{heroText?.page}</span>
        </div>
        <h1 className='text-center text-2xl font-bold text-white'>{heroText?.title}</h1>
        {heroText?.description && (
          <p className='text-center text-xs font-normal text-white'>{heroText?.description}</p>
        )}
      </div>
      {children}
    </div>
  )
}
